import Tr from "translations/Translations"
export const PurchasingGroupTemplateFieldType = {
    TEXT: "TEXT",
    DATE: "DATE",
    NUMBER: "NUMBER",
    PERCENTAGE: "PERCENTAGE",
    AGGREGATE: "AGGREGATE"
}
const TR_PREFIX = "template_field_"
export const PurchasingGroupTemplateFieldTypeLabel = (type) => Tr(TR_PREFIX + type.toLowerCase());
